import { defineComponent, ref } from 'vue-demi';
import { OrButtonV2, OrIcon, useResponsive } from '@onereach/ui-components';
import { useToggle, onClickOutside } from '@vueuse/core';
import { u as useI18n } from './useI18n-9d7aeec3.js';
import { resolveComponent, openBlock, createElementBlock, createVNode, withModifiers, normalizeClass, withCtx, withDirectives, createElementVNode, createBlock, renderSlot, Fragment, renderList, vShow } from 'vue';
import { s as styleInject } from './style-inject.es-20d2f1f5.js';
import { s as script$2 } from './EmojiPicker-87253538.js';
import { Chat } from '@or-sdk/chat';

var script$1 = defineComponent({
  name: 'ServiceNavigationUtilitiesMenuItem',
  components: {
    OrButton: OrButtonV2
  },
  props: {
    icon: {
      type: String,
      required: false,
      default: null
    },
    label: {
      type: String,
      required: true
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false
    },
    handler: {
      type: Function,
      required: true
    }
  },
  setup() {
    const {
      translate
    } = useI18n();
    return {
      translate
    };
  },
  computed: {
    translatedLabel() {
      return this.translate(this.label);
    }
  }
});

const _hoisted_1$1 = {
  class: "service-navigation-utilities-menu-item"
};
function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_or_button = resolveComponent("or-button");
  return openBlock(), createElementBlock("div", _hoisted_1$1, [createVNode(_component_or_button, {
    type: "text",
    content: _ctx.translatedLabel,
    icon: _ctx.icon,
    "is-disabled": _ctx.isDisabled,
    color: "neutral-6",
    onClick: withModifiers(_ctx.handler, ["prevent"])
  }, null, 8 /* PROPS */, ["content", "icon", "is-disabled", "onClick"])]);
}

var css_248z$1 = "/**\n * A simple way to manage mobile breakpoints described in https://davidwalsh.name/write-media-queries-sass.\n * Can be further extended using following approach https://rimdev.io/making-media-query-mixins-with-sass/\n */\n@keyframes spinAround-0f22ba7c {\nfrom {\n    transform: rotate(0);\n}\nto {\n    transform: rotate(359deg);\n}\n}\n@keyframes fade-0f22ba7c {\nfrom {\n    opacity: 1;\n}\nto {\n    opacity: 0;\n}\n}\nhtml.dark .service-navigation-utilities-menu-item .or-button[data-v-0f22ba7c], [data-theme=dark-mode] .service-navigation-utilities-menu-item .or-button[data-v-0f22ba7c] {\n  color: var(--c-neutral-0);\n}\nhtml.dark .service-navigation-utilities-menu-item .or-button[data-v-0f22ba7c] .or-icon, [data-theme=dark-mode] .service-navigation-utilities-menu-item .or-button[data-v-0f22ba7c] .or-icon {\n  color: var(--c-neutral-0);\n}\n.service-navigation-utilities-menu-item .or-button[data-v-0f22ba7c] {\n  justify-content: start;\n  width: 100%;\n  padding: var(--s-2) 12px;\n  font-size: 14px;\n  font-weight: normal;\n  white-space: nowrap;\n  border-radius: 0;\n}\n@media only screen and (max-width: 576px) {\n.service-navigation-utilities-menu-item .or-button[data-v-0f22ba7c] {\n    --or-button-height: var(--s-6);\n}\n}\n.service-navigation-utilities-menu-item .or-button[data-v-0f22ba7c] .or-button-left-icon {\n  margin-right: 0;\n}\n@media (hover: hover) and (pointer: fine) {\n.service-navigation-utilities-menu-item .or-button[data-v-0f22ba7c]:not(:disabled):not(.service-navigation-utilities-menu-item .or-button:not(:disabled).is-loading):not(.service-navigation-utilities-menu-item .or-button:not(:disabled).is-disabled):not(.service-navigation-utilities-menu-item .or-button:not(:disabled).is-readonly):not(.service-navigation-utilities-menu-item .or-button:not(:disabled):disabled):not(.service-navigation-utilities-menu-item .or-button:not(:disabled).is-focused):not(.service-navigation-utilities-menu-item .or-button:not(:disabled):active):hover {\n    background-color: var(--c-neutral-1);\n}\n}\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n.service-navigation-utilities-menu-item .or-button[data-v-0f22ba7c]:not(:disabled):not(.service-navigation-utilities-menu-item .or-button:not(:disabled).is-loading):not(.service-navigation-utilities-menu-item .or-button:not(:disabled).is-disabled):not(.service-navigation-utilities-menu-item .or-button:not(:disabled).is-readonly):not(.service-navigation-utilities-menu-item .or-button:not(:disabled):disabled):not(.service-navigation-utilities-menu-item .or-button:not(:disabled).is-focused):not(.service-navigation-utilities-menu-item .or-button:not(:disabled):active):hover {\n    background-color: var(--c-neutral-1);\n}\n}\n.service-navigation-utilities-menu-item[data-v-0f22ba7c] .or-icon {\n  width: var(--s-4);\n  height: var(--s-4);\n  margin-right: var(--s-3);\n  font-size: var(--s-4);\n}";
styleInject(css_248z$1);

script$1.render = render$1;
script$1.__scopeId = "data-v-0f22ba7c";
script$1.__file = "src/components/ServiceNavigationUtilitiesMenu/ServiceNavigationUtilitiesMenuItem.vue";

function openChildWindow(url) {
  let windowConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    title: '',
    width: 835,
    height: 600
  };
  const y = window.outerHeight / 2 + window.screenY - windowConfig.height / 2;
  const x = window.outerWidth / 2 + window.screenX - windowConfig.width / 2;
  const params = `
      toolbar=no,
      location=no,
      directories=no,
      status=no,
      menubar=no,
      resizable=no,
      copyhistory=no,
      scrollbars=no,
      width=${windowConfig.width},
      height=${windowConfig.height},
      top=${y},
      left=${x}
  `;
  const newWindow = window.open(url, windowConfig.title, params);
  newWindow === null || newWindow === void 0 ? void 0 : newWindow.focus();
}

var script = defineComponent({
  name: 'ServiceNavigationUtilitiesMenu',
  components: {
    EmojiPicker: script$2,
    OrIcon,
    OrButton: OrButtonV2,
    ServiceNavigationUtilitiesMenuItem: script$1
  },
  props: {
    config: {
      type: Object,
      default: null,
      required: true
    },
    closeOnClickOutside: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  emits: ['open', 'close'],
  setup(props, _ref) {
    let {
      emit
    } = _ref;
    const content = ref(null);
    const [isOpen, toggle] = useToggle();
    const [isEmojiPickerOpened, emojiPickerToggle] = useToggle();
    const {
      isDesktop
    } = useResponsive();
    const close = () => {
      toggle(false);
      emit('close');
    };
    const open = () => {
      toggle(true);
      emit('open');
    };
    onClickOutside(content, () => {
      if (isOpen.value && props.closeOnClickOutside) close();
      if (isEmojiPickerOpened) emojiPickerToggle(false);
    });
    return {
      isOpen,
      content,
      open,
      close,
      isDesktop,
      isEmojiPickerOpened,
      emojiPickerToggle
    };
  },
  computed: {
    drawerButtonClasses() {
      return ['widgets-button', {
        pressed: this.isOpen
      }];
    },
    contentClasses() {
      return ['content', {
        'emoji-picker-active': this.isEmojiPickerOpened
      }];
    },
    items() {
      const items = [];
      // AI assist
      if (this.config.AI_ASSIST_CHAT_UI_URL) {
        items.push({
          icon: 'chat',
          label: 'services.aiassist.label',
          isDisabled: false,
          handler: () => {
            Chat.launchChatBotWindow({
              token: this.config.token,
              contextType: 'service-navigation',
              targetFlowName: '',
              title: '',
              chatUrl: this.config.AI_ASSIST_CHAT_UI_URL
            }, {
              discoveryUrl: this.config.SERVICE_DISCOVERY_API_URL
            });
          }
        });
      }
      //emoji picker
      items.push({
        icon: 'mood',
        label: 'components.emojipicker.label',
        isDisabled: false,
        handler: async () => {
          this.emojiPickerToggle(true);
        }
      });
      // Soft Phone
      if (this.config.SOFT_PHONE_UI_URL) {
        items.push({
          icon: 'phone_iphone',
          label: 'services.softphone.label',
          isDisabled: false,
          handler: () => {
            openChildWindow(this.config.SOFT_PHONE_UI_URL, {
              title: 'Soft phone',
              width: 550,
              height: 900
            });
          }
        });
      }
      return items;
    }
  }
});

const _hoisted_1 = {
  class: "dropdown-container"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_or_icon = resolveComponent("or-icon");
  const _component_or_button = resolveComponent("or-button");
  const _component_EmojiPicker = resolveComponent("EmojiPicker");
  const _component_service_navigation_utilities_menu_item = resolveComponent("service-navigation-utilities-menu-item");
  return openBlock(), createElementBlock("div", _hoisted_1, [createVNode(_component_or_button, {
    class: normalizeClass(_ctx.drawerButtonClasses),
    icon: "widgets",
    color: "neutral-6",
    size: "small",
    onClick: _cache[0] || (_cache[0] = withModifiers($event => _ctx.isOpen ? _ctx.close() : _ctx.open(), ["prevent"]))
  }, {
    default: withCtx(() => [createVNode(_component_or_icon, {
      class: "expand_more",
      icon: "expand_more"
    })]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["class"]), withDirectives(createElementVNode("div", {
    ref: "content",
    class: normalizeClass(_ctx.contentClasses)
  }, [_ctx.isEmojiPickerOpened ? (openBlock(), createBlock(_component_EmojiPicker, {
    key: 0
  })) : renderSlot(_ctx.$slots, "content", {
    key: 1
  }, () => [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.items, item => {
    return openBlock(), createBlock(_component_service_navigation_utilities_menu_item, {
      key: item.label,
      handler: item.handler,
      label: item.label,
      icon: item.icon,
      "is-disabled": item.isDisabled
    }, null, 8 /* PROPS */, ["handler", "label", "icon", "is-disabled"]);
  }), 128 /* KEYED_FRAGMENT */))])], 2 /* CLASS */), [[vShow, _ctx.isOpen]])]);
}

var css_248z = "/**\n * A simple way to manage mobile breakpoints described in https://davidwalsh.name/write-media-queries-sass.\n * Can be further extended using following approach https://rimdev.io/making-media-query-mixins-with-sass/\n */\n@keyframes spinAround-01634ee2 {\nfrom {\n    transform: rotate(0);\n}\nto {\n    transform: rotate(359deg);\n}\n}\n@keyframes fade-01634ee2 {\nfrom {\n    opacity: 1;\n}\nto {\n    opacity: 0;\n}\n}\n.dropdown-container[data-v-01634ee2] {\n  position: relative;\n}\n@media only screen and (max-width: 576px) {\n.dropdown-container[data-v-01634ee2] {\n    position: unset;\n}\n}\n.dropdown-container .widgets-button[data-v-01634ee2] {\n  padding: var(--s-1);\n  cursor: pointer;\n  user-select: none;\n}\n.dropdown-container .widgets-button[data-v-01634ee2] .or-button-left-icon {\n  margin: 0;\n}\n.dropdown-container .widgets-button .expand_more[data-v-01634ee2] >  .or-icon {\n  font-size: 16px;\n}\n.dropdown-container .widgets-button[data-v-01634ee2] .or-icon {\n  font-size: 24px;\n  color: var(--c-neutral-4);\n}\n.dropdown-container .widgets-button.pressed[data-v-01634ee2] {\n  pointer-events: none;\n  background-color: var(--c-neutral-0) !important;\n}\n.dropdown-container .widgets-button.pressed[data-v-01634ee2] .or-icon {\n  color: var(--c-neutral-6);\n}\n@media (hover: hover) and (pointer: fine) {\n.dropdown-container .widgets-button.pressed[data-v-01634ee2]:not(.dropdown-container .widgets-button.pressed.is-loading):not(.dropdown-container .widgets-button.pressed.is-disabled):not(.dropdown-container .widgets-button.pressed.is-readonly):not(.dropdown-container .widgets-button.pressed:disabled):not(.dropdown-container .widgets-button.pressed.is-focused):not(.dropdown-container .widgets-button.pressed:active):hover {\n    background-color: unset;\n}\n.dropdown-container .widgets-button.pressed[data-v-01634ee2]:not(.dropdown-container .widgets-button.pressed.is-loading):not(.dropdown-container .widgets-button.pressed.is-disabled):not(.dropdown-container .widgets-button.pressed.is-readonly):not(.dropdown-container .widgets-button.pressed:disabled):not(.dropdown-container .widgets-button.pressed.is-focused):not(.dropdown-container .widgets-button.pressed:active):hover .or-icon {\n    color: unset;\n}\n}\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n.dropdown-container .widgets-button.pressed[data-v-01634ee2]:not(.dropdown-container .widgets-button.pressed.is-loading):not(.dropdown-container .widgets-button.pressed.is-disabled):not(.dropdown-container .widgets-button.pressed.is-readonly):not(.dropdown-container .widgets-button.pressed:disabled):not(.dropdown-container .widgets-button.pressed.is-focused):not(.dropdown-container .widgets-button.pressed:active):hover {\n    background-color: unset;\n}\n.dropdown-container .widgets-button.pressed[data-v-01634ee2]:not(.dropdown-container .widgets-button.pressed.is-loading):not(.dropdown-container .widgets-button.pressed.is-disabled):not(.dropdown-container .widgets-button.pressed.is-readonly):not(.dropdown-container .widgets-button.pressed:disabled):not(.dropdown-container .widgets-button.pressed.is-focused):not(.dropdown-container .widgets-button.pressed:active):hover .or-icon {\n    color: unset;\n}\n}\n@media (hover: hover) and (pointer: fine) {\n.dropdown-container .widgets-button[data-v-01634ee2]:not(.pressed):not(.dropdown-container .widgets-button:not(.pressed).is-loading):not(.dropdown-container .widgets-button:not(.pressed).is-disabled):not(.dropdown-container .widgets-button:not(.pressed).is-readonly):not(.dropdown-container .widgets-button:not(.pressed):disabled):not(.dropdown-container .widgets-button:not(.pressed).is-focused):not(.dropdown-container .widgets-button:not(.pressed):active):hover {\n    background-color: #42464c;\n}\n.dropdown-container .widgets-button[data-v-01634ee2]:not(.pressed):not(.dropdown-container .widgets-button:not(.pressed).is-loading):not(.dropdown-container .widgets-button:not(.pressed).is-disabled):not(.dropdown-container .widgets-button:not(.pressed).is-readonly):not(.dropdown-container .widgets-button:not(.pressed):disabled):not(.dropdown-container .widgets-button:not(.pressed).is-focused):not(.dropdown-container .widgets-button:not(.pressed):active):hover .or-icon {\n    color: var(--c-neutral-0);\n}\n}\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n.dropdown-container .widgets-button[data-v-01634ee2]:not(.pressed):not(.dropdown-container .widgets-button:not(.pressed).is-loading):not(.dropdown-container .widgets-button:not(.pressed).is-disabled):not(.dropdown-container .widgets-button:not(.pressed).is-readonly):not(.dropdown-container .widgets-button:not(.pressed):disabled):not(.dropdown-container .widgets-button:not(.pressed).is-focused):not(.dropdown-container .widgets-button:not(.pressed):active):hover {\n    background-color: #42464c;\n}\n.dropdown-container .widgets-button[data-v-01634ee2]:not(.pressed):not(.dropdown-container .widgets-button:not(.pressed).is-loading):not(.dropdown-container .widgets-button:not(.pressed).is-disabled):not(.dropdown-container .widgets-button:not(.pressed).is-readonly):not(.dropdown-container .widgets-button:not(.pressed):disabled):not(.dropdown-container .widgets-button:not(.pressed).is-focused):not(.dropdown-container .widgets-button:not(.pressed):active):hover .or-icon {\n    color: var(--c-neutral-0);\n}\n}\n.content[data-v-01634ee2] {\n  position: absolute;\n  right: 0;\n  z-index: 45;\n  width: 200px;\n  padding: var(--s-2) 0;\n  background-color: var(--c-neutral-0);\n  border-radius: 3px;\n  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.08);\n}\n@media only screen and (max-width: 576px) {\n.content[data-v-01634ee2] {\n    position: absolute;\n    justify-content: space-between;\n    width: 100%;\n    max-width: 320px;\n    margin-right: var(--s-4);\n}\n}\n.content.emoji-picker-active[data-v-01634ee2] {\n  width: auto;\n  max-width: unset;\n  padding: 0;\n}";
styleInject(css_248z);

script.render = render;
script.__scopeId = "data-v-01634ee2";
script.__file = "src/components/ServiceNavigationUtilitiesMenu/ServiceNavigationUtilitiesMenu.vue";

export { script as s };
